import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export async function sendUpdateEmail(emailParams: {
  serviceRequestId: string;
  subject: string;
  details: string;
}) {
  try {
    const res = await fetcher(
      `${API_BASE_PATH}/update-email`,
      {
        method: 'POST',
        body: emailParams,
      },
      undefined
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
